import 'tiredjs';

import './components/ActusWrapper';
import './components/FilterWrapper';
import './components/Form';
import './components/GouvWrapper';
import './components/Header';
import './components/HistoryWrapper';
import './components/HouseWrapper';
import './components/JobsSubWrapper';
import './components/MainActusWrapper';
import './components/MoreJobs';
import './components/Search';
import './components/Slider';
import './components/Modal';
import './components/BtnLisez.js';



// WEBPACK FOOTER //
// ./src/scripts/main.js